module.exports = __webpack_public_path__ + "static/media/5.3377f40f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/novopolotsk/5.jpg
// module id = 247
// module chunks = 0